import { useCallback, useMemo } from 'react';

import { Visit, VisitUpdateCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandOptions, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { useFormController } from '@dreryk/react-common';
import { usePushBack } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { VisitFormBean, VisitFormController } from './visitForm.types';
import { createCommonVisitParameters, mapVisitToVisitFormBean } from './visitForm.utils';

export const useVisitFormController = (visit: Visit): VisitFormController => {
   return useFormController<VisitFormBean>(
      useMemo(() => mapVisitToVisitFormBean(visit), [visit]),
      {
         resetAfterSubmit: true,
      }
   );
};

export const useUpdateVisitCommand = (
   visitId: Visit['id'],
   options?: UseCqrsCommandOptions<void, VisitFormBean>
): UseCqrsCommandResult<void, VisitFormBean> => {
   return useCqrsCommand<void, VisitFormBean>((parameters) => {
      const command = new VisitUpdateCommand();
      command.visitId = visitId;
      command.commonVisitParameters = createCommonVisitParameters(parameters);
      return command;
   }, options);
};

export const useVisitPushBack = (): VoidFunction => {
   const pushBack = usePushBack();
   return useCallback(() => {
      pushBack(visitPaths.getAppointmentsListPath());
   }, [pushBack]);
};
